import { createStore, applyMiddleware } from 'redux'
import {
  createAuthMiddleware,
  getInitialAuthState,
  storage
} from 'redux-simple-auth'
import unifiedAuthenticator from 'authenticators/unified'
import reducer from 'reducers'
import { compose } from 'recompose'

const authMiddleware = createAuthMiddleware({
  authenticator: unifiedAuthenticator,
  authorize: ({ token }, header) => {
    if (token) {
      header('Authorization', `Bearer ${token}`)
    }
  },
  storage
})

export default createStore(
  reducer,
  compose(
    applyMiddleware(authMiddleware),
    getInitialAuthState({ storage }),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
)



// WEBPACK FOOTER //
// ./src/config/store.js